import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const GroupManagementPage = withSuspense(
	lazy(async () => await import('./group-management-page.component')),
	PageLoader,
);
